// App shell: Sidebar, Topbar, Layout
import React from 'react';
import { Icon, Pyramid } from './icons.jsx';

const NAV = [
  { id: "today", label: "Today", icon: "today", count: "9·16" },
  { id: "dashboard", label: "Dashboard", icon: "grid" },
  { id: "projects", label: "Projects", icon: "layers", count: "8" },
  { id: "calendar", label: "Calendar", icon: "calendar" },
  { id: "blocks", label: "Blocks", icon: "tag", count: "6" },
  { id: "braindump", label: "Brain dump", icon: "inbox", count: "4" },
  { id: "ai", label: "AI organizer", icon: "sparkles" },
  { id: "reflection", label: "Reflection", icon: "book" },
];

const NAV_2 = [
  { id: "settings", label: "Settings", icon: "sliders" },
];

const Sidebar = ({ view, setView }) => (
  <aside className="sidebar">
    <div className="sidebar__brand">
      <div style={{ color: "var(--accent)" }}><Pyramid size={28} /></div>
      <div>
        <div className="name">Project<em>OS</em></div>
        <div className="sub">Successful Citizen</div>
      </div>
    </div>

    <nav className="nav">
      <div className="nav__group">Workspace</div>
      {NAV.map(n => (
        <button key={n.id} className="nav__item" data-active={view === n.id ? "1" : "0"} onClick={() => setView(n.id)}>
          <Icon name={n.icon} />
          <span>{n.label}</span>
          {n.count && <span className="count tnum">{n.count}</span>}
        </button>
      ))}
      <div className="nav__group">Account</div>
      {NAV_2.map(n => (
        <button key={n.id} className="nav__item" data-active={view === n.id ? "1" : "0"} onClick={() => setView(n.id)}>
          <Icon name={n.icon} />
          <span>{n.label}</span>
        </button>
      ))}
    </nav>

    <div className="sidebar__footer">
      <div className="avatar">E</div>
      <div className="who">
        <span className="nm">Eduard Gabriel</span>
        <span className="pl">Builder · v1.3</span>
      </div>
      <button className="iconbtn" style={{ marginLeft: "auto" }} title="Sign out">
        <Icon name="more" />
      </button>
    </div>
  </aside>
);

const MobileTab = ({ view, setView }) => {
  const items = [
    { id: "today", label: "Today", icon: "today" },
    { id: "projects", label: "Projects", icon: "layers" },
    { id: "calendar", label: "Calendar", icon: "calendar" },
    { id: "braindump", label: "Inbox", icon: "inbox" },
    { id: "settings", label: "More", icon: "more" },
  ];
  return (
    <nav className="mobile-tab">
      {items.map(n => (
        <button key={n.id} className="mobile-tab__item" data-active={view === n.id ? "1" : "0"} onClick={() => setView(n.id)}>
          <Icon name={n.icon} size={20} />
          <span>{n.label}</span>
        </button>
      ))}
    </nav>
  );
};

const Topbar = ({ view, theme, setTheme }) => {
  const labels = {
    today: "Today",
    dashboard: "Dashboard",
    projects: "Projects",
    project: "Pipeline launch",
    calendar: "Calendar",
    blocks: "Block templates",
    braindump: "Brain dump",
    ai: "AI organizer",
    reflection: "Reflection",
    settings: "Settings",
    login: "Sign in",
  };
  return (
    <header className="topbar">
      <div className="topbar__crumb">
        <span>Workspace</span>
        <span className="sep"><Icon name="chev_right" size={12} /></span>
        <span className="now">{labels[view] || view}</span>
      </div>
      <div className="topbar__search">
        <Icon name="search" size={14} />
        <input placeholder="Search projects, tasks, dumps…" />
        <kbd>⌘K</kbd>
      </div>
      <div className="topbar__actions">
        <button className="iconbtn" onClick={() => setTheme(theme === "dark" ? "light" : "dark")} title="Theme">
          <Icon name={theme === "dark" ? "sun" : "moon"} />
        </button>
        <button className="iconbtn" title="Notifications"><Icon name="bell" /></button>
        <button className="btn btn--accent btn--sm">
          <Icon name="plus" size={14} />
          <span>Capture</span>
        </button>
      </div>
    </header>
  );
};

export { Sidebar, Topbar, MobileTab };
